import {Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const Label = styled(Text)`
  flex-grow: 1;
`;

export const StyledMenu = styled.menu`
  list-style: none;
  padding: 0;
  margin: 0;
  transition: opacity 0.3s;
  transition-delay: 0.4s;
  opacity: 1;
  pointer-events: auto;

  &[data-is-transitioning='true'] {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const ScrollAnchor = styled.div`
  position: absolute;
  top: 0;
`;

export const UnstyledList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 4px;

  &[data-increase-grid-gap='true'] {
    gap: 5px;
  }
`;
